exports = module.exports = require("../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer{position:absolute;bottom:0;left:0;border-top:1px solid #f0f0f0;width:100%;height:60px;margin-top:-1px;background-color:#fff;z-index:99}.footer .item{padding:5px 0}.footer .item a{display:block}.footer .item img{display:block;margin:0 auto;height:30px}.footer .item p{margin-bottom:0;text-align:center}.footer .item a p{font-size:14px;color:#a6a6a6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./src/styles/footer.css
// module id = 802
// module chunks = 0